exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imgUserProfileEdit{width:120px;height:120px}.captionField{font-family:VazirFD;font-weight:400;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6104ceb3","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/ListUserInfo/Components/UserProfileEdit.vue
// module id = 564
// module chunks = 0